"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campolongo-tapogliano": {
    "5854c749": [{
      "hkey": "51052eff",
      "slug": "tapogliano",
      "name": "Tapogliano",
      "primary": true,
      "skipSearch": false
    }],
    "topogliano": [{
      "hkey": "51052eff",
      "slug": "tapogliano",
      "name": "Tapogliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "85de8b8d": [{
      "hkey": "64019576",
      "slug": "campolongo-al-torre-cavenzano",
      "name": "Campolongo al Torre-Cavenzano",
      "primary": true,
      "skipSearch": false
    }],
    "cavenzano": [{
      "hkey": "64019576",
      "slug": "campolongo-al-torre-cavenzano",
      "name": "Campolongo al Torre-Cavenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bb9ba3c1": [{
      "hkey": "a86de4e2",
      "slug": "campolongo-tapogliano",
      "name": "Campolongo Tapogliano",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardo": [{
      "hkey": "a86de4e2",
      "slug": "campolongo-tapogliano",
      "name": "Campolongo Tapogliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;